/* istanbul ignore file */

export const FREE_UK_DELIVERY = 'Free UK Delivery';
export const PRODUCT_OUT_OF_STOCK = 'Out of stock';
export const PRODUCT_UNAVAILABLE = 'No longer available';
export const NEW = 'New';
